import React, { useState } from 'react';


export default function Contact() {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    description: ''
  });
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  return (
    <>
      <div className="relative">
        <div
          className="bg-cover bg-center text-center text-white p-8 "
          style={{
            backgroundImage: `url("./images/innerb.jpg")`,
          }}
        >
          <div className="text-center pt-40 pb-28">
            <h1 className="text-2xl md:text-4xl font-bold">Contact</h1>
          </div>
        </div>
      </div>

      <div className="container  mx-auto my-10 ">
        <div className="flex flex-wrap">
          <div className='w-1/2 p-2'>
            <h2 className="font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide mt-2 mb-4 px-3">
              Get in touch today
            </h2>
            <p className=' px-3 pb-3'>Fill out this brief form and we'll be back in touch with more information.</p>
            <form onSubmit={handleSubmit}>
              <div className="p-3">
                <label
                  className="block text-[#607D8B] text-sm  mb-2"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
                  placeholder="Please select your title"
                  required
                />
              </div>
              <div className="p-3">
                <label
                  className="block text-[#607D8B] text-sm  mb-2"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
                  placeholder="Please select your title"
                  required
                />
              </div>
              <div className='p-3'>
                <label
                  className="block text-[#607D8B] text-sm mb-2"
                  htmlFor="description"
                >
                  Description
                </label>

                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="resize-none border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] px-3 py-2 "
                  rows={4}
                  placeholder="Enter a description"

                ></textarea>
                <button
                  className="bg-[#B4804A] text-white font-semibold  w-32 py-2 px-4 mb-8 rounded-md mt-4"
                  type="submit"
                >
                  Submit
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>

    </>
  );
}
